// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"120":"1e4a7ff1","856":"2b58c028","860":"b6352b01"}[chunkId] + ".js";
};